import type { FC } from 'react';

import { ChatTabType, useChatSlice } from '../../../store/slices/chat';

import { Chat } from './Chat';
import { ChatFooterConnected } from './footer/ChatFooterConnected';
import { MessagesWrapperConnected } from './messages/messagesWrapper';
import { ChatTabsConnected } from './tabs/ChatTabsConnected';

export const ChatConnected: FC = () => {
  const selectedTab = useChatSlice.getSelectedTab();
  const gameChatMessages = useChatSlice.getGameChatMessages();
  const liveSupportChatMessages = useChatSlice.getLiveSupportChatMessages();

  return (
    <Chat
      chatTabs={<ChatTabsConnected />}
      messagesWrapper={
        selectedTab === ChatTabType.GameChat ? (
          <MessagesWrapperConnected key={selectedTab} messages={gameChatMessages} />
        ) : (
          <MessagesWrapperConnected key={selectedTab} messages={liveSupportChatMessages} />
        )
      }
      chatFooter={<ChatFooterConnected />}
    />
  );
};
